import { useState, useCallback } from "react";
import { RecurringTransactionsResponse } from "../../../services/recurringTransactions/types";
import {
  AnyTransaction,
  DeleteKind,
  UseTransactionsModalsReturn,
} from "./types";

/**
 * Custom hook to manage modal states
 */
export const useTransactionsModals = (): UseTransactionsModalsReturn => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteKind, setDeleteKind] = useState<DeleteKind>(null);
  const [showRecurringEditWarning, setShowRecurringEditWarning] =
    useState(false);
  const [selectedTransaction, setSelectedTransaction] =
    useState<AnyTransaction | null>(null);
  const [pendingRecurringEdit, setPendingRecurringEdit] =
    useState<RecurringTransactionsResponse | null>(null);

  const openDeleteModal = useCallback(
    (transaction: AnyTransaction, kind: DeleteKind = "recurring") => {
      setSelectedTransaction(transaction);
      setDeleteKind(kind);
      setDeleteModal(true);
    },
    [],
  );

  const closeDeleteModal = useCallback(() => {
    setDeleteModal(false);
    setDeleteKind(null);
    setSelectedTransaction(null);
  }, []);

  const openRecurringEditWarning = useCallback(
    (transaction: RecurringTransactionsResponse) => {
      setPendingRecurringEdit(transaction);
      setShowRecurringEditWarning(true);
    },
    [],
  );

  const closeRecurringEditWarning = useCallback(() => {
    setShowRecurringEditWarning(false);
    setPendingRecurringEdit(null);
  }, []);

  return {
    deleteModal,
    deleteKind,
    showRecurringEditWarning,
    selectedTransaction,
    pendingRecurringEdit,
    openDeleteModal,
    closeDeleteModal,
    openRecurringEditWarning,
    closeRecurringEditWarning,
    setSelectedTransaction,
    setPendingRecurringEdit,
  };
};
